import apiUrlsNotifier from "./apiUrlsNotifier";
import { fetchCookieJwtWithRefreshToken } from "./fetchCookieJwt";
export const createNotification = async ({ toUsers, type, payload, }) => {
    const { url, method } = apiUrlsNotifier.createNotification;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(),
        method,
        jsonBody: {
            toUsers,
            notificationType: type,
            payload,
        },
    });
    return res;
};
const mapNotifDrc = (n) => ({
    id: n.uuid,
    creation: n.creation,
    type: n.notificationType,
    from: n.from,
    markedAsRead: !!n.markedAsRead,
    markedAsViewed: !!n.markedAsViewed,
    payload: n.payload,
});
export const getAllNotifDrc = async ({ size = 200, from = 0, filter, }) => {
    const { url, method } = apiUrlsNotifier.getNotifications;
    try {
        const res = await fetchCookieJwtWithRefreshToken({
            url: url(size, from, filter),
            method,
        });
        return res.map(mapNotifDrc);
    }
    catch (err) {
        console.warn("getNotifications: ", err);
        return [];
    }
};
export const getCountNotifDrc = async (filter = "to_view") => {
    const { url, method } = apiUrlsNotifier.getNotificationsCount;
    try {
        const res = await fetchCookieJwtWithRefreshToken({
            url: url(filter),
            method,
        });
        return res;
    }
    catch (err) {
        console.warn("getNotificationsCount: ", err);
        return 0;
    }
};
export const getOneNotifDrc = async (id) => {
    const { url, method } = apiUrlsNotifier.getNotificationById;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(id),
        method,
    });
    return mapNotifDrc(res);
};
export const deleteNotifDrc = async (id) => {
    if (!!id) {
        const { url, method } = apiUrlsNotifier.removeNotification;
        const res = await fetchCookieJwtWithRefreshToken({
            url: url(id),
            method,
        });
        return res;
    }
    else {
        const { url, method } = apiUrlsNotifier.deleteNotifications;
        const res = await fetchCookieJwtWithRefreshToken({
            url: url(),
            method,
        });
        return res;
    }
};
export const markAsReadNotifDrc = async (mark = true, id) => {
    if (!!id) {
        const { url, method } = apiUrlsNotifier.notificationMarkRead;
        const res = await fetchCookieJwtWithRefreshToken({
            url: url(id, mark),
            method,
        });
        return res;
    }
    else {
        const { url, method } = apiUrlsNotifier.notificationMarkAllRead;
        const res = await fetchCookieJwtWithRefreshToken({
            url: url(mark),
            method,
        });
        return res;
    }
};
export const markAsViewNotifDrc = async (mark = true) => {
    const { url, method } = apiUrlsNotifier.notificationMarkAllView;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(mark),
        method,
    });
    return res;
};
export const getAllNotifJob = async () => {
    const { url, method } = apiUrlsNotifier.getJobs;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(),
        method,
    });
    return res;
};
export const getOneNotifJob = async (id) => {
    const { url, method } = apiUrlsNotifier.getJobId;
    const res = await fetchCookieJwtWithRefreshToken({
        url: url(id),
        method,
    });
    return res;
};
export const deleteNotifJob = async (id) => {
    if (!!id) {
        const { url, method } = apiUrlsNotifier.deleteJobId;
        await fetchCookieJwtWithRefreshToken({
            url: url(id),
            method,
        });
    }
    else {
        const { url, method } = apiUrlsNotifier.deleteJobs;
        await fetchCookieJwtWithRefreshToken({
            url: url(),
            method,
        });
    }
};
